import { useCallback } from 'react';
import { useIntl, type MessageDescriptor } from '@atlassian/jira-intl';

const WFM_SKILL_COMMAND = '/manage-workforce';

/**
 * Shared hook for the WFM ("manage workforce") Rovo skill. Returns a memoized formatter
 * that prefixes a translated message with the skill command so it is routed to the WFM
 * agent when sent to Rovo Chat. Used across the Schedules, Capacity, and Availability
 * surfaces (Rovo config providers and metric "Insights" CTAs).
 */
export const useWfmSkillPrompt = (): {
	formatWfmSkillPrompt: (message: MessageDescriptor) => string;
} => {
	const { formatMessage } = useIntl();

	const formatWfmSkillPrompt = useCallback(
		(message: MessageDescriptor): string => {
			return `${WFM_SKILL_COMMAND} ${formatMessage(message)}`;
		},
		[formatMessage],
	);

	return { formatWfmSkillPrompt };
};
